var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 358.66 304.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#921b1e;}.cls-2{fill:#dc3027;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6632",
    "data-name": "Group 6632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6629",
    "data-name": "Group 6629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_96-2",
    "data-name": "Union 96-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    className: "cls-1",
    d: "M206.73,154.25V287.8L17,287.82V98.1H169.4a7.08,7.08,0,0,1-.09-.79c-.23-2.42-.36-4.88-.36-7.36a70,70,0,0,1,.55-8.8H153.84l-145.29,0A8.45,8.45,0,0,0,.08,89.61V296.29a8.47,8.47,0,0,0,8.47,8.46H215.2a8.47,8.47,0,0,0,8.48-8.45h0V161.09A72,72,0,0,1,206.73,154.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_90",
    "data-name": "Subtraction 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    className: "cls-1",
    d: "M16.94,233.47H0L.07,89.63A8.48,8.48,0,0,0,8.54,98.1H17Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6627",
    "data-name": "Group 6627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6624",
    "data-name": "Group 6624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    className: "cls-2",
    d: "M69.13,232.85c-5.07,0-9.19-3.38-9.19-7.56s4.11-7.57,9.18-7.58h33.1c5.08,0,9.19,3.4,9.19,7.58s-4.11,7.56-9.19,7.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6625",
    "data-name": "Group 6625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7347",
    "data-name": "Path 7347",
    className: "cls-2",
    d: "M67.5,202.58a7.57,7.57,0,1,1,0-15.14h87.81a7.57,7.57,0,1,1,0,15.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6626",
    "data-name": "Group 6626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7348",
    "data-name": "Path 7348",
    className: "cls-2",
    d: "M67.5,164.29a7.57,7.57,0,0,1,0-15.14h87.81a7.57,7.57,0,0,1,0,15.14Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6628",
    "data-name": "Group 6628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7349",
    "data-name": "Path 7349",
    className: "cls-2",
    d: "M123.2,225.29a8.18,8.18,0,1,1,8.18,8.17h0A8.17,8.17,0,0,1,123.2,225.29Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6631",
    "data-name": "Group 6631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6630",
    "data-name": "Group 6630"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7350",
    "data-name": "Path 7350",
    className: "cls-1",
    d: "M358.61,246.2c0-.45-.08-.91-.13-1.37a23.16,23.16,0,0,0-.49-2.72,24.17,24.17,0,0,0-2.63-6.6l-47.73-82.64A90,90,0,1,0,153.79,98.09a87.85,87.85,0,0,0,1.44,10,90,90,0,0,0,68.45,69.67c.52.11,1,.23,1.55.33a91.09,91.09,0,0,0,36.26,0c1.19-.25,2.39-.52,3.58-.82L312.87,260c.26.44.51.87.8,1.29l.2.3c.17.27.36.53.56.79s.3.38.46.58a.2.2,0,0,0,.08.12c.45.55.9,1.08,1.39,1.58a1.21,1.21,0,0,0,.19.2c.2.21.39.39.58.58a20,20,0,0,0,3,2.47,7.38,7.38,0,0,0,.68.46,6.65,6.65,0,0,0,.56.36l.69.4c.37.21.74.41,1.13.6a12.22,12.22,0,0,0,1.43.64,9.2,9.2,0,0,0,1,.41c.28.11.58.21.87.31a.09.09,0,0,0,.07,0,20.85,20.85,0,0,0,2.55.68l.63.11c.36.07.72.12,1.09.17a22.7,22.7,0,0,0,3.19.22h0a24.57,24.57,0,0,0,17.5-7.36c.29-.28.56-.58.83-.88a22.44,22.44,0,0,0,2.19-2.87c.22-.33.43-.67.63-1a24.63,24.63,0,0,0,2.05-4.46A24.32,24.32,0,0,0,358.61,246.2ZM242.54,163.54a73.51,73.51,0,0,1-35.81-9.29A74.1,74.1,0,0,1,190.5,142q-2.49-2.49-4.75-5.23t-4.23-5.66a72.72,72.72,0,0,1-4.53-7.64c-.74-1.46-1.43-2.94-2.09-4.44A75,75,0,0,1,171,107.24c-.2-.8-.37-1.61-.54-2.44v0c-.13-.6-.24-1.2-.34-1.8-.29-1.6-.52-3.24-.7-4.88a5.16,5.16,0,0,1-.09-.79c-.23-2.42-.36-4.88-.36-7.35a71.93,71.93,0,0,1,.54-8.8,73.7,73.7,0,0,1,57.09-63c.52-.12,1-.23,1.58-.33s1.13-.22,1.69-.32c1.14-.2,2.27-.37,3.42-.51.57-.07,1.16-.15,1.73-.2,1.25-.13,2.49-.23,3.74-.29s2.52-.1,3.79-.1,2.55.05,3.8.1,2.48.16,3.72.29h0c1.09.11,2.16.24,3.22.4s2,.3,2.93.49h.05c1.44.27,2.87.58,4.28.94l1.56.42a73.57,73.57,0,0,1,52.41,55.61c0,.1,0,.19.05.29.2.9.36,1.8.52,2.7.27,1.59.48,3.19.66,4.82.12,1.25.23,2.49.28,3.74s.1,2.52.1,3.79A73.58,73.58,0,0,1,242.54,163.54Zm95.68,91.18a4.82,4.82,0,0,1-.5.27c-.3.14-.58.27-.9.39a9.24,9.24,0,0,1-1.37.37,8.53,8.53,0,0,1-3.95-.29,10.28,10.28,0,0,1-1-.38,8.19,8.19,0,0,1-2.15-1.49,8.38,8.38,0,0,1-1.36-1.72l-46.24-80.1a86.91,86.91,0,0,0,8.17-4.28c1.61-.94,3.17-1.93,4.7-3l.3-.2c.1-.07.2-.13.31-.22s.46-.31.7-.48l34.67,60,11.56,20v0c.08.15.17.31.24.47a5.09,5.09,0,0,1,.4,1c.1.33.19.68.26,1a6.77,6.77,0,0,1,.13,1,8.17,8.17,0,0,1-4,7.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_130",
    "data-name": "Subtraction 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7351",
    "data-name": "Path 7351",
    className: "cls-1",
    d: "M358.61,246.2c0-.45-.08-.91-.13-1.37-.12-.91-.28-1.82-.49-2.72a24.67,24.67,0,0,0-2.65-6.6l-14.15,8.19c.08.16.17.32.24.47a4.92,4.92,0,0,1,.4,1c.1.33.19.67.26,1a7.11,7.11,0,0,1,.13,1,8.18,8.18,0,0,1-4,7.54c-.17.1-.33.19-.5.27a7.89,7.89,0,0,1-.9.39,8.05,8.05,0,0,1-5.33.08,6.73,6.73,0,0,1-1-.38,8.19,8.19,0,0,1-2.15-1.49,8.73,8.73,0,0,1-1.36-1.72l-46.24-80.1a87.08,87.08,0,0,0,8.18-4.28c1.6-.93,3.16-1.92,4.69-3l.3-.21c.1-.07.2-.13.31-.22s.46-.31.71-.48l-4.48-7.75.05,0a10.08,10.08,0,0,1-.68-1.25A8.18,8.18,0,0,1,304.81,148l2.82,4.89a90,90,0,0,0-46.14-151,91.09,91.09,0,0,0-36.26,0,89.92,89.92,0,0,0-71.44,96.27,87.85,87.85,0,0,0,1.44,10,90,90,0,0,0,68.45,69.67c.52.11,1,.23,1.55.33a91.09,91.09,0,0,0,36.26,0c1.19-.25,2.39-.52,3.58-.82L312.87,260c.26.44.51.87.8,1.29l.2.3c.17.27.36.53.56.79s.3.38.46.58a.2.2,0,0,0,.08.12c.45.55.9,1.08,1.39,1.58a1.21,1.21,0,0,0,.19.2c.2.21.39.39.58.58a20,20,0,0,0,3,2.47,7.38,7.38,0,0,0,.68.46,6.65,6.65,0,0,0,.56.36l.69.4c.37.21.74.41,1.13.6a12.22,12.22,0,0,0,1.43.64,9.2,9.2,0,0,0,1,.41c.28.11.58.21.87.31a.09.09,0,0,0,.07,0,20.85,20.85,0,0,0,2.55.68l.63.11c.36.07.72.12,1.09.17a22.7,22.7,0,0,0,3.19.22h0a24.57,24.57,0,0,0,17.5-7.36c.29-.28.56-.58.83-.88a24.44,24.44,0,0,0,2.19-2.87c.22-.33.43-.67.63-1a24.7,24.7,0,0,0,3.34-14ZM242.54,163.54a73.51,73.51,0,0,1-35.81-9.29A74.1,74.1,0,0,1,190.5,142q-2.49-2.49-4.75-5.23a70,70,0,0,1-4.23-5.66,72.72,72.72,0,0,1-4.53-7.64q-1.11-2.19-2.09-4.44A74,74,0,0,1,171,107.24c-.2-.8-.37-1.61-.54-2.44v0c-.13-.6-.24-1.2-.34-1.8-.3-1.6-.53-3.24-.7-4.88a5.16,5.16,0,0,1-.09-.79,72.21,72.21,0,0,1-.37-7.35,70,70,0,0,1,.53-8.8,73.63,73.63,0,0,1,57.11-63c.52-.12,1-.23,1.58-.33s1.13-.22,1.69-.32c1.14-.2,2.27-.37,3.42-.51.58-.07,1.16-.15,1.74-.2,1.24-.13,2.48-.23,3.73-.29s2.52-.1,3.79-.1,2.55.05,3.8.1,2.49.16,3.72.29h0c1.09.11,2.16.24,3.22.4s2,.31,2.93.49h.05c1.44.27,2.87.58,4.28.94l1.56.42a73.82,73.82,0,0,1,52.41,55.61c0,.1,0,.19.06.29q.27,1.35.51,2.7c.27,1.59.49,3.19.66,4.82.13,1.25.23,2.49.28,3.74s.1,2.52.1,3.79A73.58,73.58,0,0,1,242.54,163.54Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_7352",
    "data-name": "Path 7352",
    className: "cls-2",
    d: "M209,67.05a8.18,8.18,0,1,1-8.19-8.19A8.18,8.18,0,0,1,209,67.05Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg1);
export default __webpack_public_path__ + "static/media/img_1.86fe083df0fae0e0bd05334fb6274697.svg";
export { ForwardRef as ReactComponent };